import * as requestFromServer from './periodeKurbanCrud';
import { periodeKurbanSlice, callTypes } from './periodeKurbanSlice';
import { actions as auth } from '../../../Auth/_redux/authRedux'
import { toastOption } from '../../../../../_metronic/_helpers/ToastHelpers'
import { toast } from 'react-toastify'

const { actions } = periodeKurbanSlice;

export const fetchPeriodeKurbans = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.findPeriodeKurban(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.periodeKurbansFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchPeriodeKurban = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.periodeKurbanFetched({ periodeKurbanForEdit: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getPeriodeKurbanById(id)
        .then(response => {
            const { data: periodeKurban } = response.data; // alias data -> donatur
            dispatch(actions.periodeKurbanFetched({ periodeKurbanForEdit: periodeKurban }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const createPeriodeKurban = (periodeKurbanForCreation) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.createPeriodeKurban(periodeKurbanForCreation)
        .then(response => {
            dispatch(actions.periodeKurbanReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const updatePeriodeKurban = (periodeKurban) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.updatePeriodeKurban(periodeKurban)
        .then(response => {
            dispatch(actions.periodeKurbanReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};


export const deletePeriodeKurban = (periodeKurban) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.deletePeriodeKurban(periodeKurban)
        .then(response => {
            dispatch(actions.periodeKurbanReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const changeStatusPeriodeKurban = (uuid, status) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.deletePeriodeKurban(uuid, status)
        .then(response => {
            dispatch(actions.periodeKurbanReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

